var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 12.174v-8.35L5.487 5.306a1.027 1.027 0 0 1-1.438 0 .988.988 0 0 1 0-1.415L8.003 0l3.948 3.887a.988.988 0 0 1 0 1.415 1.027 1.027 0 0 1-1.438 0L9 3.82v8.36l1.513-1.483a1.027 1.027 0 0 1 1.438 0 .988.988 0 0 1 0 1.415l-3.948 3.887-3.954-3.89a.988.988 0 0 1 0-1.416 1.027 1.027 0 0 1 1.438 0L7 12.174z"}));
}

Sort.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Sort;

Sort.default = Sort;
